<div [class]="'login-image' + ' ' + (cssClass() ?? '')" >
  <div class="gradient-overlay"></div>
  <div class="bubbles">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>

  <div class="image-content">
    <div class="brand-logo" style="cursor: pointer;" (click)="goHome()">
      <div class="icon-tile">
        <img
          src="assets/images/clccthattea-v2-logo-main.svg"
          alt="Clocc That Tea Logo"
          />
      </div>
    </div>
    <h2 class="welcome-text">{{ welcomeText() }}</h2>
    <div class="welcome-subtitle">
     {{welcomeSubtitle()}}
    </div>
  </div>
  <div class="footer-divider"></div>
  <div class="left-footer">
    © {{ year() }} Clocc That Tea. &nbsp;<a [href]="insizonUrl"> All rights reserved.</a>
  </div>
</div>
